export const driversHeaderElements = [
  { label: "Nombre y apellido", value: "nombreApellido", align: "inherit" },
  { label: "Equipos", value: "equipos", align: "inherit" },
  { label: "Estado", value: "estado", align: "inherit" },
];
